import { useQuery } from '@tanstack/react-query';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPageReport: aiReportTypes.GetReport = ({ reportId }) => {
  return axios.get(`/page-reports/${reportId}`);
};

type QueryFnType = typeof getPageReport;

type UseGetPageReportOptions = {
  reportId: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPageReport = ({ reportId, config = {} }: UseGetPageReportOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['page-report', reportId],
    enabled: Boolean(reportId),
    queryFn: () => getPageReport({ reportId }),
    refetchInterval: (data) => {
      const status = data?.report.status;
      return status === 'queued' || status === 'running' ? 4000 : false;
    },
  });
};
